(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.SetupService = (function(superClass) {
    extend(SetupService, superClass);

    function SetupService(http, rootScope, factory) {
      this.http = http;
      this.rootScope = rootScope;
      this.factory = factory;
      this.deactivateProduct = bind(this.deactivateProduct, this);
      this.activateProduct = bind(this.activateProduct, this);
      this.updateProduct = bind(this.updateProduct, this);
      this.createProducts = bind(this.createProducts, this);
      this.getProducts = bind(this.getProducts, this);
      this.deleteTreatment = bind(this.deleteTreatment, this);
      this.saveTreatment = bind(this.saveTreatment, this);
      this.getTreatments = bind(this.getTreatments, this);
      this.deleteTraitPackage = bind(this.deleteTraitPackage, this);
      this.saveTraitPackage = bind(this.saveTraitPackage, this);
      this.getTraitSuppliers = bind(this.getTraitSuppliers, this);
      this.getTraitPackages = bind(this.getTraitPackages, this);
      this.getSeedCompanies = bind(this.getSeedCompanies, this);
      null;
    }

    SetupService.prototype.getSeedCompanies = function(lineups_id) {
      var params;
      params = {
        lineups_id: lineups_id
      };
      return this.http.post('backend/portal/ratings/seed-companies/load', params).then(function(response) {
        return response.data;
      }).then((function(_this) {
        return function(response) {
          var i, j, len, obj, props, ref, ref1;
          if (((ref = response.status) != null ? ref.type : void 0) === 'success') {
            ref1 = response.data.seed_companies;
            for (i = j = 0, len = ref1.length; j < len; i = ++j) {
              props = ref1[i];
              obj = _this.factory.make('SeedCompany', props);
              response.data.seed_companies[i] = obj;
            }
          }
          return response;
        };
      })(this));
    };

    SetupService.prototype.getTraitPackages = function(lineups_id) {
      var params;
      params = {
        lineups_id: lineups_id
      };
      return this.http.post('backend/portal/ratings/trait-packages/load', params).then(function(response) {
        return response.data;
      }).then((function(_this) {
        return function(response) {
          var i, j, len, obj, props, ref, ref1;
          if (((ref = response.status) != null ? ref.type : void 0) === 'success') {
            ref1 = response.data.trait_packages;
            for (i = j = 0, len = ref1.length; j < len; i = ++j) {
              props = ref1[i];
              obj = _this.factory.make('TraitPackage', props);
              response.data.trait_packages[i] = obj;
            }
          }
          return response;
        };
      })(this));
    };

    SetupService.prototype.getTraitSuppliers = function() {
      var params;
      params = {};
      return this.http.post('backend/portal/ratings/trait-packages/load-trait-suppliers', params).then(function(response) {
        return response.data;
      }).then((function(_this) {
        return function(response) {
          var i, j, len, obj, props, ref, ref1;
          if (((ref = response.status) != null ? ref.type : void 0) === 'success') {
            ref1 = response.data.trait_suppliers;
            for (i = j = 0, len = ref1.length; j < len; i = ++j) {
              props = ref1[i];
              obj = _this.factory.make('TraitSupplier', props);
              response.data.trait_suppliers[i] = obj;
            }
          }
          return response;
        };
      })(this));
    };

    SetupService.prototype.saveTraitPackage = function(lineups_id, trait_package) {
      var params;
      params = {
        lineups_id: lineups_id,
        id: trait_package.id,
        name: trait_package.name,
        suffix: trait_package.suffix,
        description: trait_package.description,
        trait_suppliers_id: trait_package.trait_suppliers_id
      };
      return this.http.post('backend/portal/ratings/trait-packages/save', params).then(function(response) {
        return response.data;
      }).then((function(_this) {
        return function(response) {
          var obj, ref;
          if (((ref = response.status) != null ? ref.type : void 0) === 'success') {
            obj = _this.factory.make('TraitPackage', response.data);
            response.data = obj;
          }
          return response;
        };
      })(this));
    };

    SetupService.prototype.deleteTraitPackage = function(lineups_id, trait_package) {
      var params;
      params = {
        lineups_id: lineups_id,
        id: trait_package.id
      };
      return this.http.post('backend/portal/ratings/trait-packages/delete', params).then(function(response) {
        return response.data;
      });
    };

    SetupService.prototype.getTreatments = function(lineups_id) {
      var params;
      params = {
        lineups_id: lineups_id
      };
      return this.http.post('backend/portal/ratings/treatments/load', params).then(function(response) {
        return response.data;
      }).then((function(_this) {
        return function(response) {
          var i, j, len, obj, props, ref, ref1;
          if (((ref = response.status) != null ? ref.type : void 0) === 'success') {
            ref1 = response.data.treatments;
            for (i = j = 0, len = ref1.length; j < len; i = ++j) {
              props = ref1[i];
              obj = _this.factory.make('Treatment', props);
              response.data.treatments[i] = obj;
            }
          }
          return response;
        };
      })(this));
    };

    SetupService.prototype.saveTreatment = function(lineups_id, treatment) {
      var params;
      params = {
        lineups_id: lineups_id,
        id: treatment.id,
        name: treatment.name,
        treatment_code: treatment.treatment_code,
        description: treatment.description
      };
      return this.http.post('backend/portal/ratings/treatments/save', params).then(function(response) {
        return response.data;
      }).then((function(_this) {
        return function(response) {
          var obj, ref;
          if (((ref = response.status) != null ? ref.type : void 0) === 'success') {
            obj = _this.factory.make('Treatment', response.data);
            response.data = obj;
          }
          return response;
        };
      })(this));
    };

    SetupService.prototype.deleteTreatment = function(lineups_id, treatment) {
      var params;
      params = {
        lineups_id: lineups_id,
        id: treatment.id
      };
      return this.http.post('backend/portal/ratings/treatments/delete', params).then(function(response) {
        return response.data;
      });
    };

    SetupService.prototype.getProducts = function(lineups_id) {
      var params;
      params = {
        lineups_id: lineups_id
      };
      return this.http.post('backend/portal/ratings/products/load', params).then(function(response) {
        return response.data;
      }).then((function(_this) {
        return function(response) {
          var i, j, len, obj, props, ref, ref1;
          if (((ref = response.status) != null ? ref.type : void 0) === 'success') {
            ref1 = response.data.products;
            for (i = j = 0, len = ref1.length; j < len; i = ++j) {
              props = ref1[i];
              obj = _this.factory.make('Product', props);
              response.data.products[i] = obj;
            }
          }
          return response;
        };
      })(this));
    };

    SetupService.prototype.createProducts = function(lineups_id, products) {
      var j, len, params, product;
      params = {
        lineups_id: lineups_id,
        products: []
      };
      for (j = 0, len = products.length; j < len; j++) {
        product = products[j];
        params.products.push({
          seed_companies_id: product.seed_companies_id,
          name: product.name,
          trait_packages_id: product.trait_packages_id
        });
      }
      return this.http.post('backend/portal/ratings/products/create', params).then(function(response) {
        return response.data;
      }).then((function(_this) {
        return function(response) {
          var i, k, len1, obj, ref, ref1;
          if (((ref = response.status) != null ? ref.type : void 0) === 'success') {
            ref1 = response.data;
            for (i = k = 0, len1 = ref1.length; k < len1; i = ++k) {
              product = ref1[i];
              obj = _this.factory.make('Product', product);
              response.data[i] = obj;
            }
          }
          return response;
        };
      })(this));
    };

    SetupService.prototype.updateProduct = function(lineups_id, product) {
      var params;
      params = {
        lineups_id: lineups_id,
        id: product.id,
        seed_companies_id: product.seed_companies_id,
        name: product.name,
        trait_packages_id: product.trait_packages_id
      };
      return this.http.post('backend/portal/ratings/products/update', params).then(function(response) {
        return response.data;
      }).then((function(_this) {
        return function(response) {
          var obj, ref;
          if (((ref = response.status) != null ? ref.type : void 0) === 'success') {
            obj = _this.factory.make('Product', response.data);
            response.data = obj;
          }
          return response;
        };
      })(this));
    };

    SetupService.prototype.activateProduct = function(lineups_id, product) {
      var params;
      params = {
        lineups_id: lineups_id,
        id: product.id
      };
      return this.http.post('backend/portal/ratings/products/activate', params).then(function(response) {
        return response.data;
      }).then((function(_this) {
        return function(response) {
          var obj, ref;
          if (((ref = response.status) != null ? ref.type : void 0) === 'success') {
            if (response.data.seed_company != null) {
              obj = _this.factory.make('SeedCompany', response.data.seed_company);
              response.data.seed_company = obj;
            }
            if (response.data.trait_package != null) {
              obj = _this.factory.make('TraitPackage', response.data.trait_package);
              response.data.trait_package = obj;
            }
          }
          return response;
        };
      })(this));
    };

    SetupService.prototype.deactivateProduct = function(lineups_id, product) {
      var params;
      params = {
        lineups_id: lineups_id,
        id: product.id
      };
      return this.http.post('backend/portal/ratings/products/deactivate', params).then(function(response) {
        return response.data;
      });
    };

    return SetupService;

  })(Service);

}).call(this);
